import { render, staticRenderFns } from "./BaseFoodCard.vue?vue&type=template&id=505d90ab&scoped=true&"
import script from "./BaseFoodCard.vue?vue&type=script&lang=js&"
export * from "./BaseFoodCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseFoodCard.vue?vue&type=style&index=0&id=505d90ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d90ab",
  null
  
)

export default component.exports